/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Canceled_AtInputs */

const en_settings_billing_canceled_at = /** @type {(inputs: Settings_Billing_Canceled_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled at`)
};

/**
* | output |
* | --- |
* | "Canceled at" |
*
* @param {Settings_Billing_Canceled_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_canceled_at = /** @type {((inputs?: Settings_Billing_Canceled_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Canceled_AtInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_canceled_at(inputs)
});
export { settings_billing_canceled_at as "settings.billing.canceled_at" }